import React, { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import MenuCard from './card/menucard';
import Modal from '@mui/material/Modal';
import './menu-list.scss'
import EmptyIcon from "@mui/icons-material/MenuOpenTwoTone";
import axios from '../../../../../../../api/axios';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';



function ItemList() {

  const business_entity_id = sessionStorage.getItem("configBizEntityId");
  const [searchTerm, setSearchTerm] = useState('');
  const [menuItems, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [skuCodes, setSkuCodes] = useState([]);


  const [openModal, setOpenModal] = useState(false);
  const [newItemName, setNewItemName] = useState('');
  const [newItemPrice, setNewItemPrice] = useState('');
  const [newItemCGST, setNewItemCGST] = useState('');
  const [newItemSGST, setNewItemSGST] = useState('');
  const [newItemBarcode, setNewItemBarcode] = useState('');
  const [newItemSKUCode, setNewItemSKUCode] = useState('');
  const [newItemHSNCode, setNewItemHSNCode] = useState('');
  const [newItemDescription, setNewItemDescription] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [editingItemId, setEditingItemId] = useState(null);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    fetchData();
  }, [business_entity_id]);

  const fetchData = async () => {
    try {
      const responseCategories = await axios.get(`retail/categories/${business_entity_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      setCategories(responseCategories.data);

      const responseMenuItems = await axios.get(`retail/products/${business_entity_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      setMenuItems(responseMenuItems.data);


      const responseSkuCodes = await axios.get(`retail/sku/${business_entity_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      const transformedSkuCodes = responseSkuCodes.data.map(sku => ({
        id: sku.id,
        code: sku.sku_code,
        label: sku.sku_code // This will be displayed in the dropdown
      }));
      setSkuCodes(transformedSkuCodes);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleAddItem = () => {
    setNewItemName('');
    setNewItemDescription('');
    setNewItemPrice('');
    setNewItemCGST('');
    setNewItemSGST('');
    setNewItemBarcode('');
    setNewItemSKUCode('');
    setNewItemHSNCode('');
    setSelectedCategory('');
    setEditingItemId(null);
    setOpenModal(true);
  };

  const handleEditItem = (item) => {
    console.log("eddit", item)
    setNewItemName(item.name);
    setNewItemDescription(item.description || '');
    setNewItemPrice(item.price);
    setNewItemCGST(item.cgst);
    setNewItemSGST(item.sgst);
    setNewItemBarcode(item.barcode || '');
    setNewItemSKUCode(item.category_sku_id || '');
    setNewItemHSNCode(item.hsn_code || '');
    setSelectedCategory(item.category_id);
    setEditingItemId(item.id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleItemSubmit = async () => {

    const priceIsValid = !isNaN(newItemPrice) && Number(newItemPrice) >= 0;
    const cgstIsValid = !isNaN(newItemCGST) && Number(newItemCGST) >= 0;
    const sgstIsValid = !isNaN(newItemSGST) && Number(newItemSGST) >= 0;

    if (!priceIsValid || !cgstIsValid || !sgstIsValid) {
      setSnackbarMessage("Price, CGST, and SGST must be valid numbers.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    try {
      const url = editingItemId
        ? 'retail/product'
        : 'retail/product';

      const payload = {
        name: newItemName,
        description: newItemDescription,
        price: newItemPrice,
        cgst: newItemCGST,
        sgst: newItemSGST,
        barcode: newItemBarcode,
        skuCodeid: newItemSKUCode || null,
        hsnCode: newItemHSNCode,
        categoryId: selectedCategory || null,
        businessEntityId: business_entity_id
      };

      if (editingItemId) {
        payload.id = editingItemId;
      }

      const methods = editingItemId ? axios.put : axios.post;
      const response = await methods(url, payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });

      if (response.status === 200) {
        const successMessage = editingItemId ? "Menu item updated successfully!" : "Menu item added successfully!";
        setSnackbarMessage(successMessage);
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        setOpenModal(false);
        fetchData();
      }
      else if (response.status === 230) {
        const errorMessage = "The SKU code is already used by another menu item!";
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        fetchData();
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(error.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };


  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== 'text/csv') {
      setSnackbarMessage("Please upload a valid CSV file.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    const maxFileSize = 5 * 1024 * 1024; //5 mb
    if (file.size > maxFileSize) {
      setSnackbarMessage("File size exceeds the maximum limit of 5MB.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('businessEntityId', business_entity_id);

    setIsUploading(true);

    try {
      const response = await axios.post(
        '/businessEntities/upload-menu-csv',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: false,
        }
      );

      const successMessage = response.data.message || "Menu CSV uploaded successfully!";
      fetchData();

      setSnackbarMessage(successMessage);
      setSnackbarSeverity('success');
      setOpenSnackbar(true);

    } catch (error) {
      let errorMessage = 'Something went wrong with the menu CSV upload!';

      if (error.response) {
        errorMessage = error.response.data.error || `Error: ${error.response.statusText}`;
      } else if (error.request) {
        errorMessage = 'No response from the server. Please try again later.';
      } else {
        errorMessage = `Request error: ${error.message}`;
      }

      console.error('Error uploading CSV:', error);
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleDelete = async (menu_id) => {
    try {
      const response = await axios.delete(`retail/product/${menu_id}`);

      if (response.status === 200) {
        fetchData();
        setSnackbarMessage("Item deleted successfully");
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting menu item:", error);
      setSnackbarMessage("Failed to delete menu item");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const filteredItems = menuItems.filter(item => {
    return item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase());
  });


  const [filteredOptions, setFilteredOptions] = useState(skuCodes);
  const [inputValue, setInputValue] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track dropdown state

  const handleInputClick = () => {
    setFilteredOptions(skuCodes); // Show full list on click
    setIsDropdownOpen(true); // Open dropdown
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    setInputValue(value);

    if (value.trim() === "") {
      setFilteredOptions(skuCodes); // Show all options when empty
    } else {
      setFilteredOptions(
        skuCodes.filter((item) =>
          item.label.toLowerCase().includes(value.toLowerCase())
        )
      );
    }

    setIsDropdownOpen(true); // Keep dropdown open while typing
  };

  const handleSelect = (id) => {
    if (skuCodes.find((item) => item.id === id)) {
      const selectedOption = skuCodes.find((item) => item.id === id);
      setInputValue(selectedOption.label); // Display selected value
      setNewItemSKUCode(selectedOption.id); // Update SKU Code in state
    } else {
      setNewItemSKUCode("");
    }

    setIsDropdownOpen(false); // Close dropdown after selection
  };


  const [file, setFile] = useState(null);

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch("http://195.133.93.175:5001/retail/upload-retail-data", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
    alert(result.message);
  };

  return (
    <div className="wrap">
      <div className="roww">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {/* <a href="/assets/templates/menu.csv" download="menu.csv" style={{ textDecoration: 'none' }}>
            Download CSV Template ?
          </a> */}
        </div>
        <div className="search">
          <input
            type="text"
            className="searchTerm"
            placeholder="Search items"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={handleAddItem}
            style={{ backgroundColor: '#4CAF50', color: 'white', marginRight: '10px' }}
          >
            Add Item
          </Button>

          <input type="file" onChange={(e) => setFile(e.target.files[0])} />
          <Button
            variant="contained"
            // onClick={() => fileInputRef.current.click()}
            style={{ backgroundColor: '#2196F3', color: 'white', marginRight: '10px' }}
            onClick={handleUpload}
          >
            {isUploading ? <CloudUploadIcon /> : "Upload CSV"}
          </Button>
        </div>
      </div>
      <div className="menu-container">
        <Grid container spacing={2} justifyContent="center">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.menu_id}>
                <MenuCard item={item} onEdit={() => handleEditItem(item)} onDelete={() => handleDelete(item.id)} />
              </Grid>
            ))
          ) : (
            <div className="empty-list">
              <EmptyIcon style={{ fontSize: 100 }} />
              <p>No items found</p>
            </div>
          )}
        </Grid>
      </div>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className="modal-container">
          <h4>{editingItemId ? "Edit Menu Item" : "Add Menu Item"}</h4>
          <form>
            <div className="form-group">
              <label>
                Name:
                <input
                  type="text"
                  value={newItemName}
                  onChange={(e) => setNewItemName(e.target.value)}
                  required
                  className="form-input"
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Price:
                <input
                  type="number"
                  value={newItemPrice}
                  onChange={(e) => setNewItemPrice(e.target.value)}
                  required
                  className="form-input"
                />
              </label>
            </div>
            <div style={{ display: "flex", gap: "1rem" }}>

              <div className="form-group" style={{ flex: 1 }}>
                <label>
                  SGST:
                  <input
                    type="number"
                    value={newItemSGST}
                    onChange={(e) => setNewItemSGST(e.target.value)}
                    required
                    className="form-input"
                  />
                </label>
              </div>
              <div className="form-group" style={{ flex: 1 }}>
                <label>
                  CGST:
                  <input
                    type="number"
                    value={newItemCGST}
                    onChange={(e) => setNewItemCGST(e.target.value)}
                    required
                    className="form-input"
                  />
                </label>
              </div>
            </div>

            {
              skuCodes.length > 0 && (
                <div className="form-group" style={{ position: "relative" }}>
                  <label>
                    SKU Code:
                    <input
                      type="text"
                      value={inputValue}
                      onChange={handleInputChange}
                      onClick={handleInputClick} // Show dropdown on click
                      className="form-input"
                    />
                  </label>
                  {isDropdownOpen && (
                    <ul
                      style={{
                        position: "absolute",
                        background: "#fff",
                        border: "1px solid #ccc",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredOptions.map((item) => (
                        <>
                          <li onClick={() => handleSelect(0)}>Unlink sku</li>
                          <li
                            key={item.id}
                            onClick={() => handleSelect(item.id)}
                            style={{ padding: "8px", cursor: "pointer" }}
                          >
                            {item.label}
                          </li>
                        </>
                      ))}
                    </ul>
                  )}
                </div>
              )
            }

            <div className="form-group">
              <label>
                Category:
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  required
                  className="form-select"
                >
                  <option value="" disabled>Select a category</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            <div style={{ display: "flex", gap: "1rem" }}>
              <div className="form-group" style={{ flex: 1 }}>
                <label>
                  Barcode:
                  <input
                    type="text"
                    value={newItemBarcode}
                    onChange={(e) => setNewItemBarcode(e.target.value)}
                    className="form-input"
                  />
                </label>
              </div>

            </div>

            <div className="form-group">
              <label>
                HSN Code:
                <input
                  type="text"
                  value={newItemHSNCode}
                  onChange={(e) => setNewItemHSNCode(e.target.value)}
                  className="form-input"
                />
              </label>
            </div>
            <div className="modal-actions">
              <Button variant="contained" color="primary" onClick={handleItemSubmit}>
                {editingItemId ? "Update" : "Add"}
              </Button>
              <Button variant="contained" onClick={handleCloseModal}>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </Modal>


      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} severity={snackbarSeverity} onClose={handleSnackbarClose}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default ItemList;
